import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { Provider, useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState, store } from "./redux/store";
import { listenForAuthChanges, listenToUserData } from "./redux/authSlice";
import Profile from "./AUTH/profile";
import logoImg from "./assets/app/logo.png";

import Checkout from "./APP/DASHBOARD/Checkout";
import CustomerOrders from "./APP/CUSTOMER/customerorders";
import OwnerDashboard from "./APP/DASHBOARD/ownerdashboard";

import Shop from "./APP/DASHBOARD/Shop";
import { CurrencyProvider } from "./GLOBAL/Currencies";
import { LanguageProvider } from "./GLOBAL/Languages";
import AccountSecurity from "./AUTH/accountsecurity";
import EditProfile from "./AUTH/editprofile";
import ComingSoon from "./GLOBAL/ComingSoon";
import Authentication from "./AUTH/authentication";
import Makeup from "./APP/DASHBOARD/Makeup";
import Explore from "./APP/DASHBOARD/Explore";
import Home from "./APP/DASHBOARD/Home";
import Details from "./APP/DASHBOARD/Details";



/* ═══════════════════════════ 3D LOADER: black, white and red ═══════════════════════════ */
const LOADER_CSS = `
@import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:wght@500;600&family=Jost:wght@400;500&display=swap');
.ld{position:fixed;inset:0;z-index:9999;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:64px;background:#000;color:#fff;overflow:hidden}
.ld *{box-sizing:border-box}
.ld-stage{position:relative;width:140px;height:140px;perspective:700px;display:flex;align-items:center;justify-content:center}
.ld-rig{position:relative;width:72px;height:72px;transform-style:preserve-3d;animation:ldSpin 4.2s linear infinite, ldBob 2.1s ease-in-out infinite}
.ld-cube,.ld-core{position:absolute;inset:0;transform-style:preserve-3d}
.ld-core{animation:ldSpinRev 3s linear infinite}
.ld-f{position:absolute;inset:0;border:1px solid rgba(255,255,255,.9);backface-visibility:visible}
.ld-cube .ld-f{background:linear-gradient(135deg,rgba(255,60,60,.92) 0%,rgba(225,0,0,.88) 45%,rgba(120,0,0,.92) 100%);
  box-shadow:inset 0 0 18px rgba(255,255,255,.35),inset 6px 6px 14px rgba(255,255,255,.25)}
.ld-cube .ld-f::after{content:"";position:absolute;top:8%;left:8%;width:46%;height:16%;border-radius:999px;background:linear-gradient(90deg,rgba(255,255,255,.85),rgba(255,255,255,0));transform:rotate(-24deg)}
.ld-core .ld-f{background:linear-gradient(135deg,#fff,#d9d9d9);border-color:#fff}
.ld-cube .ld-f:nth-child(1){transform:rotateY(0deg) translateZ(36px)}
.ld-cube .ld-f:nth-child(2){transform:rotateY(180deg) translateZ(36px)}
.ld-cube .ld-f:nth-child(3){transform:rotateY(90deg) translateZ(36px)}
.ld-cube .ld-f:nth-child(4){transform:rotateY(-90deg) translateZ(36px)}
.ld-cube .ld-f:nth-child(5){transform:rotateX(90deg) translateZ(36px)}
.ld-cube .ld-f:nth-child(6){transform:rotateX(-90deg) translateZ(36px)}
.ld-core{inset:22px}
.ld-core .ld-f:nth-child(1){transform:rotateY(0deg) translateZ(14px)}
.ld-core .ld-f:nth-child(2){transform:rotateY(180deg) translateZ(14px)}
.ld-core .ld-f:nth-child(3){transform:rotateY(90deg) translateZ(14px)}
.ld-core .ld-f:nth-child(4){transform:rotateY(-90deg) translateZ(14px)}
.ld-core .ld-f:nth-child(5){transform:rotateX(90deg) translateZ(14px)}
.ld-core .ld-f:nth-child(6){transform:rotateX(-90deg) translateZ(14px)}
.ld-shadow{position:absolute;bottom:-34px;left:50%;width:84px;height:16px;margin-left:-42px;border-radius:50%;
  background:radial-gradient(ellipse at center,rgba(225,0,0,.65) 0%,rgba(225,0,0,0) 70%);animation:ldShadow 2.1s ease-in-out infinite}
.ld-text{font-family:'Cormorant Garamond',serif;font-weight:600;font-size:13px;letter-spacing:.5em;padding-left:.5em;animation:ldPulse 1.8s ease-in-out infinite}
@keyframes ldSpin{from{transform:rotateX(-24deg) rotateY(0deg)}to{transform:rotateX(-24deg) rotateY(360deg)}}
@keyframes ldSpinRev{from{transform:rotateX(0deg) rotateY(0deg) rotateZ(0deg)}to{transform:rotateX(360deg) rotateY(-360deg) rotateZ(180deg)}}
@keyframes ldBob{0%,100%{margin-top:0}50%{margin-top:-14px}}
@keyframes ldShadow{0%,100%{transform:scale(1);opacity:.9}50%{transform:scale(.7);opacity:.5}}
@keyframes ldPulse{0%,100%{opacity:.4}50%{opacity:1}}
@media (prefers-reduced-motion:reduce){.ld-rig,.ld-core,.ld-shadow,.ld-text{animation:none}.ld-rig{transform:rotateX(-24deg) rotateY(35deg)}}
`;

const Loader = () => (
  <div className="ld" role="status" aria-live="polite">
    <style>{LOADER_CSS}</style>
    <div className="ld-stage" aria-hidden="true">
      <div className="ld-rig">
        <div className="ld-cube"><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /></div>
        <div className="ld-core"><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /><i className="ld-f" /></div>
      </div>
      <span className="ld-shadow" />
    </div>
    <span className="ld-text">LOADING</span>
  </div>
);

/* ═══════════════════════════ ROUTING ═══════════════════════════ */
const Protected = () => {
  const user = useSelector((s: RootState) => s.auth.user);
  return user ? <Outlet /> : <Navigate to="/auth" replace />;
};


const AppRoutes = () => {
  const dispatch = useDispatch<AppDispatch>();
  const { user, authLoaded } = useSelector((state: RootState) => state.auth);


  useEffect(() => {
    const handleContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };

    document.addEventListener('contextmenu', handleContextMenu);

    return () => {
      document.removeEventListener('contextmenu', handleContextMenu);
    };
  }, []);



  useEffect(() => {
    dispatch(listenForAuthChanges());
  }, [dispatch]);


{/*
    useEffect(() => {
  if (user) {
    // 1 hour = 60 minutes × 60 seconds × 1000 ms = 3,600,000 ms
    dispatch(startInactivityWatcher({ timeoutMs: 60 * 60 * 1000 }));
  }
}, [dispatch, user]);


  */}








  if (!authLoaded) {
    return <AppLoadingScreen />;
  }



  const ProtectedSupportRoute = () => {
    const authUser = useSelector((state: RootState) => state.auth.user);

    if (!authUser) return <Navigate to="/AuthSwitch" replace />;

    const hasAccess = authUser.role?.includes("support") || authUser.role?.includes("admin");

    if (!hasAccess) return <Navigate to="/" replace />;

    return <Outlet />;
  };

  return (
    <>

    <Routes>
      {/* ✅ Publicly accessible pages/tabs */}
      <Route
  path="/"
  element={
    <>


        {/*



  <GeneralHomes/>

    <HomeLive />

      <WhatsNew />
        <Route index element={<Ahome />} />

       */}
    </>
  }
/>




        <Route path="/" element={<Outlet  />}>

<Route index element={<RootRedirect />} />

<Route path="/comingsoon" element={<ComingSoon />} />
      <Route path="/AuthSwitch" element={<Authentication />} />

        <Route path="/makeup" element={<Explore />} />



      <Route element={<Protected />}>

        <Route path="/profile/:userId" element={<Profile />} />
                <Route path="/editprofile/:userId" element={<EditProfile />} />
          <Route path="/account-security/:userId" element={<AccountSecurity />} />

        <Route path="/shop" element={<Shop />} />
        <Route path="/makeup" element={<Makeup />} />
        <Route path="/details/:productId" element={<Details />} />

        <Route path="/checkout" element={<Checkout />} />
        <Route path="/orders" element={<CustomerOrders />} />
        <Route path="/owner" element={<OwnerDashboard />} />
      </Route>



    <Route path="*" element={<Navigate to={user ? "/" : "/authswitch"} replace />} />
        </Route>


    </Routes>
</>
);};


/* ═══════════════════════════ LIPSTICK LOADER ═══════════════════════════ */

/* nine very different shades, one per lipstick */
const LIPSTICKS = [
  "#D10A2B", // classic red
  "#FF2E93", // hot pink
  "#FF6F3C", // coral orange
  "#C98B7B", // nude
  "#8E1B4B", // berry
  "#B0668C", // mauve
  "#5B1A4D", // plum
  "#6B2D22", // chocolate
  "#FF8FB8", // bubblegum
];

const BOOT_CSS = `
  @keyframes aeBootSpin { to { background-position: 300% 0; } }
  @keyframes aeBootHop {
    0%, 100% { transform: translateY(0) rotate(0deg); }
    35%      { transform: translateY(-26px) rotate(-5deg); }
    65%      { transform: translateY(-8px) rotate(3deg); }
  }
  @keyframes aeBootSwatch {
    0%, 100% { transform: scaleX(1); opacity: .55; }
    35%      { transform: scaleX(.55); opacity: .25; }
  }
  @keyframes aeBootText { 0%, 100% { opacity: .45; } 50% { opacity: 1; } }
  .ae-lip { animation: aeBootHop 1.3s cubic-bezier(.34,1.4,.64,1) infinite; transform-origin: 50% 100%; }
  .ae-swatch { animation: aeBootSwatch 1.3s ease-in-out infinite; }
  @media (prefers-reduced-motion: reduce) { .ae-lip, .ae-swatch { animation: none !important; } }
`;

/* one lipstick, drawn in SVG; the gradients live once in <LipstickDefs/> and are shared */
const LipstickDefs: React.FC = () => (
  <svg width="0" height="0" style={{ position: "absolute" }} aria-hidden="true" focusable="false">
    <defs>
      <linearGradient id="aeGold" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0" stopColor="#8A6A1C" />
        <stop offset=".35" stopColor="#FFE9A0" />
        <stop offset=".7" stopColor="#D9A93A" />
        <stop offset="1" stopColor="#8A6A1C" />
      </linearGradient>
      <linearGradient id="aeTube" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0" stopColor="#0d0d0d" />
        <stop offset=".3" stopColor="#3a3a3a" />
        <stop offset=".6" stopColor="#141414" />
        <stop offset="1" stopColor="#000" />
      </linearGradient>
      <linearGradient id="aeShade" x1="0" x2="1" y1="0" y2="0">
        <stop offset="0" stopColor="#fff" stopOpacity=".28" />
        <stop offset=".45" stopColor="#fff" stopOpacity="0" />
        <stop offset="1" stopColor="#000" stopOpacity=".32" />
      </linearGradient>
    </defs>
  </svg>
);

const Lipstick: React.FC<{ color: string }> = ({ color }) => (
  <svg viewBox="0 0 40 130" style={{ width: "100%", height: "auto", display: "block", overflow: "visible" }} aria-hidden="true">
    {/* the bullet: slanted, rounded tip */}
    <path d="M11 66 V26 Q11 11 21 6 Q28 12 29 32 V66 Z" fill={color} />
    <path d="M11 66 V26 Q11 11 21 6 Q28 12 29 32 V66 Z" fill="url(#aeShade)" />
    <rect x="14" y="26" width="3" height="30" rx="1.5" fill="#fff" opacity=".4" />
    {/* gold collar */}
    <rect x="9" y="64" width="22" height="11" rx="2.5" fill="url(#aeGold)" stroke="#000" strokeWidth="1.2" />
    {/* black tube with a gold ring */}
    <rect x="8" y="75" width="24" height="52" rx="4" fill="url(#aeTube)" stroke="#000" strokeWidth="1.2" />
    <rect x="8" y="88" width="24" height="5" fill="url(#aeGold)" stroke="#000" strokeWidth="1" />
    <rect x="12" y="96" width="2.6" height="26" rx="1.3" fill="#fff" opacity=".22" />
  </svg>
);

const AppLoadingScreen: React.FC = () => {
  const CARD_COUNT = 5;
  const RADIUS = 34; // how far each petal card sits from center
  const CARD_SIZE = 84; // matches the logo's own width/height

  // 5 cards fanned around a center point like petals — front card (i=0)
  // sits centered and on top, the rest fan out behind it.
  const cards = Array.from({ length: CARD_COUNT }, (_, i) => {
    const angle = (360 / CARD_COUNT) * i - 90; // start at 12 o'clock
    const rad = (angle * Math.PI) / 180;
    const x = i === 0 ? 0 : Math.cos(rad) * RADIUS;
    const y = i === 0 ? 0 : Math.sin(rad) * RADIUS;
    return { x, y, z: CARD_COUNT - i, scale: i === 0 ? 1 : 0.72, delay: i * 0.15 };
  });

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: 44,
        zIndex: 9999,
        overflow: "hidden",
        backgroundColor: "#FFF0F7",
        backgroundImage:
          "radial-gradient(#FFD0E6 2.2px, transparent 2.4px), radial-gradient(#FFF8CC 2.2px, transparent 2.4px)",
        backgroundSize: "26px 26px, 26px 26px",
        backgroundPosition: "0 0, 13px 13px",
      }}
    >
      <style>{BOOT_CSS}</style>
      <LipstickDefs />

      {/* logo card, stacked 5x in a flower fan; the frame glows through lipstick shades */}
      <div
        style={{
          position: "relative",
          width: CARD_SIZE + RADIUS * 2,
          height: CARD_SIZE + RADIUS * 2,
        }}
      >
        {cards.map(({ x, y, z, scale, delay }, i) => (
          <div
            key={i}
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: `translate(calc(-50% + ${x}px), calc(-50% + ${y}px)) scale(${scale})`,
              zIndex: z,
              display: "inline-flex",
              borderRadius: 28,
            }}
          >
            <div
              style={{
                position: "absolute",
                inset: -3,
                borderRadius: 31,
                background:
                  "linear-gradient(90deg,#D10A2B,#FF2E93,#FF6F3C,#B0668C,#8E1B4B,#FF8FB8,#D10A2B)",
                backgroundSize: "300% 100%",
                animation: `aeBootSpin 3s linear infinite`,
                animationDelay: `${delay}s`,
              }}
            />
            <div
              style={{
                position: "relative",
                background: "#FFFFFF",
                borderRadius: 26,
                padding: 14,
                display: "inline-flex",
                boxShadow: "0 12px 30px rgba(142,27,75,0.22)",
              }}
            >
              <img
                src={logoImg}
                alt="Alovable"
                style={{ width: 84, height: 84, objectFit: "contain", display: "block" }}
              />
            </div>
          </div>
        ))}
      </div>

      {/* 9 lipsticks, each a different shade, growing small → tall; sizes use clamp()
          so the whole row scales down together on narrow screens instead of overflowing */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          alignItems: "flex-end",
          justifyContent: "center",
          gap: "clamp(6px, 2vw, 16px)",
          maxWidth: "94vw",
          padding: "0 12px",
        }}
      >
        {LIPSTICKS.map((color, i) => {
          const MIN_W = 22;
          const MAX_W = 56;
          const w = MIN_W + ((MAX_W - MIN_W) * i) / (LIPSTICKS.length - 1);
          const vw = 4.2 + (i / (LIPSTICKS.length - 1)) * 3.4; // ~4vw → ~7.6vw across the row
          return (
            <div
              key={i}
              style={{ display: "flex", flexDirection: "column", alignItems: "center", width: `clamp(${MIN_W - 6}px, ${vw}vw, ${w}px)` }}
            >
              <div
                className="ae-lip"
                style={{
                  width: "100%",
                  animationDelay: `${i * 0.09}s`,
                  filter: "drop-shadow(0 4px 0 rgba(0,0,0,.18))",
                }}
              >
                <Lipstick color={color} />
              </div>
              {/* a little swatch smear under each one, in its own shade */}
              <span
                className="ae-swatch"
                style={{
                  display: "block",
                  width: "120%",
                  height: 7,
                  marginTop: 6,
                  borderRadius: 999,
                  background: color,
                  animationDelay: `${i * 0.09}s`,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

const RootRedirect: React.FC = () => {
  const { user } = useSelector((s: RootState) => s.auth);
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!user) return;
    const timer = setTimeout(() => setShow(true), 3000);
    return () => clearTimeout(timer);
  }, [user]);

  if (show) return <ComingSoon />;
  return <ComingSoon />;
};

const App = () => (
  <Provider store={store}>


    <Router>






  <CurrencyProvider>

<LanguageProvider
  apiKey={process.env.REACT_APP_GOOGLE_TRANSLATE_API_KEY!}
>

        <AppRoutes />



 </LanguageProvider>

       </CurrencyProvider>

    </Router>

  </Provider>
);

export default App;